export const showApploading = () => {
  const loading = document.querySelector("#app-loading");
  loading && (loading.style.display = "flex");
};

export const hideApploading = () => {
  const loading = document.querySelector("#app-loading");
  loading && (loading.style.display = "none");
};
